export default __webpack_public_path__ + "static/media/Ledger.321ddddb.svg";